import { theme } from "@project/shared";
import Head from "next/head";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 24px 15.28% 144px;
  justify-content: center;
  display: flex;
  @media (max-width: 1375px) {
    padding: 24px 120px 144px;
  }
  @media (max-width: 1075px) {
    padding: 24px 80px 80px;
  }
  @media (max-width: 920px) {
    padding: 24px 26px 80px;
  }
  @media (max-width: 768px) {
    padding: 24px 0px 60px;
  }
`;
const Container = styled.div`
  flex: 1;
  max-width: 1240px;
  & > div {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05);
  }
`;
const Header = styled.div`
  background: ${theme.base};
  padding: 16px;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 150%;
  color: ${theme.planeText};
`;
const Content = styled.div`
  background: ${theme.base};
  padding: 16px 16px 39px;
  & p,
  li {
    font-size: 14px;
    line-height: 150%;
    color: ${theme.black};
  }
  & li {
    margin-bottom: 12px;
  }
  & ol {
    margin-bottom: 24px;
    padding-left: 32px;
  }
`;
const Text = styled.p<{ list?: boolean }>`
  margin-bottom: ${({ list }) => (list ? "12px" : "24px")};
  white-space: break-spaces;
`;
const Privacy = () => {
  return (
    <Wrapper>
      <Head>
        <title>個人情報保護方針 | side bizz</title>
      </Head>
      <Container>
        <Header>個人情報保護方針</Header>
        <Content>
          <Text>
            ウェブエックス株式会社（以下「当社」）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。
          </Text>
          <Text list>1.個人情報の管理</Text>
          <Text>
            当社は、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。
          </Text>
          <Text list>2.個人情報の利用目的</Text>
          <Text>
            お客様からお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電話や電子メール、資料のご送付に利用いたします。
          </Text>
          <Text list>3.個人情報の第三者への開示・提供の禁止</Text>
          <Text list>
            当社は、お客様よりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。
          </Text>

          <ol>
            <li>お客様の事前同意がある場合</li>
            <li>
              お客様が希望されるサービスを行なうために、当社が業務を委託する業者に対して開示する場合
            </li>
            <li>法令に基づき開示することが必要である場合</li>
          </ol>
          <Text list>4.個人情報の安全対策</Text>
          <Text>
            当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。
          </Text>
          <Text list>5.ご本人の照会</Text>
          <Text>
            お客様がご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。
          </Text>
          <Text list>6.法令、規範の遵守と見直し</Text>
          <Text>
            当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。
          </Text>
          <Text list>お問い合わせ</Text>
          <Text list>
            当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。
          </Text>
          <Text>
            {"ウェブエックス株式会社\n" +
              "〒104-0061 東京都中央区銀座7丁目13番6号 サガミビル2階\n" +
              "TEL:03-6204-9795 FAX:03-6204-9796\n" +
              "Mail: info@web-x.co.jp"}
          </Text>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default Privacy;
